import { mapActions, mapGetters } from "vuex";
export const planSetter = {
  data() {
    return {
    };
  },
  props: {
    planId: String,
  },
  computed: {
    ...mapGetters("common", ["plans", "plan"]),
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    // plans: {
    //   async handler(v) {
    //     console.log("1111");
    //     await this.setPlan();
    //   },
    // },
    options: {
      async handler(v) {
        // console.log("plansetter: options changed: options: ", JSON.stringify(this.options));
        // console.log("plansetter: options changed: plans: ", JSON.stringify(this.plans));
        // console.log("plansetter: options changed: planid: ", this.planId);
        await this.setPlan();
      },
    },
  },
  methods: {
    ...mapActions("common", ["setPlanId", "setNavbarOpen", "setPlans"]),
    ...mapActions("plansMembers", ["getPlanOptions", "getUserPlans"]),
    ...mapActions("auth", ["silentRefresh", "login"]),
    async loadUserPlans() {
      try {
        var usr = await this.silentRefresh();
        // console.log("silent refresh USER: ", usr);

        if (usr) {
          let plans = (await this.getUserPlans()).data.value;
          this.setPlans(
            plans.map((o) => {
              o.Name = o.Current.Name;
              o.Description = o.Current.Description;
              o.Translations = o.Current.Translations;
              return o;
            })
          );
        }
      } catch (error) {
        // console.log("silent refresh error: ", error);
        this.login();
      }
    },
    async setPlan() {
      if (this.options !== null && this.options !== undefined) {
        // console.log("plansetter: setPlan: options ok");
        if (this.plans === null || this.plans === undefined) {
          // console.log("plansetter: setPlan: plans null or undefined");
          await this.loadUserPlans();
        }
        // console.log("plansetter: setPlan: plans ok  plans: ", JSON.stringify(this.plans));
        if (this.planId !== null && this.planId !== undefined) {
          // console.log("plansetter: setPlan: planid exists");
          if (!this.plan || (this.plan && this.plan.Id !== this.planId)) {
            await this.getPlanOptions(this.planId);
            this.setPlanId(this.planId);
          }
        }
      }
    }
  },
  async mounted() {
    // console.log("plansetter mounted options: ", JSON.stringify(this.options));
    // console.log("plansetter mounted plans: ", JSON.stringify(this.plans));
    // console.log("plansetter mounted planid: ", this.planId);
    await this.setPlan();
  }
};
